import * as types from "../actions/types";


const initialState = {
    accessLevels: null,
    contentTypes: null,
    displayTypes: null,
    transitions: null,
    timezones: null,
    fonts: null,
    tags: null
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_DICTIONNARY_ACCESSLEVELS:
            return Object.assign({}, state, {
                accessLevels: action.assets
            });
        case types.GET_DICTIONNARY_CONTENTTYPES:
            return Object.assign({}, state, {
                contentTypes: action.assets
            });
        case types.GET_DICTIONNARY_DISPLAYTYPES:
            return Object.assign({}, state, {
                displayTypes: action.assets
            });
        case types.GET_DICTIONNARY_TIMEZONES:
            return Object.assign({}, state, {
                timezones: action.assets
            });
        case types.GET_TRANSITIONS_COMPLETED:
            return Object.assign({}, state, {
                transitions: action.payload
            });
        case types.GET_FONTS_COMPLETED:
            return Object.assign({}, state, {
                fonts: action.assets
            });
        case types.GET_TAGS_COMPLETED:
            return Object.assign({}, state, {
                tags: action.assets
            });

        default:
            return state;
    }
};
